import { render } from "./contact.vue?vue&type=template&id=71e3178c&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=71e3178c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71e3178c"

export default script